// extracted by mini-css-extract-plugin
export default {"wrapper":"haa","container":"iaa","image":"jaa","info":"kaa","title":"laa","note":"maa","product":"naa","product_img":"oaa","description":"paa","name":"qaa","whybtn":"raa","buttons":"saa"};
    if(module.hot) {
      // 1714654900365
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  